import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { mostraAlerta } from "../../componentes/alerts/sweetAlert";
import { AxiosPublico } from "../../componentes/axios/Axios";
import { UsuarioActualizarContrasena } from "../../configuracion/apiUrls";
import { NegocioConfig } from "../../configuracion/Empresa";

const ActualizarContrasena = () => {
  const [correo, setCorreo] = useState("");
  const [pin, setPin] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [verificarContrasena, setVerificarContrasena] = useState("");
  const [showPasswordNueva, setShowPasswordNueva] = useState(false);
  const [showPasswordVerificar, setShowPasswordVerificar] = useState(false);
  const [errorMatch, setErrorMatch] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (errorMatch) {
      mostraAlerta("Las contraseñas no coinciden", "warning");
      return;
    }
    try {
      if (
        correo.trim() === "" ||
        pin.trim() === "" ||
        contrasena.trim() === ""
      ) {
        mostraAlerta("Complete todos los campos", "warning");
        return;
      }
      const response = await AxiosPublico.post(UsuarioActualizarContrasena, {
        correo: correo.trim(),
        pin: pin.trim(),
        contrasena: contrasena.trim(),
      });
      mostraAlerta("Contraseña actualizada correctamente", "success");
      console.log(response.data);
      setTimeout(() => navigate("/login"), 2000);
    } catch (error) {
      console.log("Error:", error);
      if (error.response) {
        if (Array.isArray(error.response.data)) {
          error.response.data.forEach((f) => {
            mostraAlerta("Campo: " + f.path + ". " + f.msg, "warning");
          });
        } else if (error.response.data.error) {
          mostraAlerta(error.response.data.error, "warning");
        } else {
          mostraAlerta("Error al actualizar la contraseña", "error");
        }
      } else {
        mostraAlerta("Error de red o servidor no disponible", "error");
      }
    }
  };

  const handlePasswordChange = (value) => {
    setContrasena(value);
    setErrorMatch(value !== verificarContrasena);
  };

  const handleVerifyPasswordChange = (value) => {
    setVerificarContrasena(value);
    setErrorMatch(value !== contrasena);
  };

  return (
    <div className="hold-transition login-page d-flex align-items-center" style={{ minHeight: "100vh" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-lg border-0 rounded-lg mt-5">
              <div className="card-body p-0">
                <div className="row no-gutters">
                  {/* Contenedor del Logo - Visible en pantallas grandes */}
                  <div className="col-lg-6 d-none d-lg-flex flex-column align-items-center justify-content-center p-5 bg-primary text-white">
                    <div className="login-logo text-center">
                      <img
                        src={NegocioConfig.imagen}
                        alt="SIGVES LOGO"
                        className="img-fluid rounded-circle"
                        style={{ width: "250px", height: "250px", marginBottom: "2rem" }}
                      />
                      <h1 className="h3 font-weight-bold">Actualiza tu Contraseña</h1>
                      <p className="lead">Introduce el PIN enviado a tu correo y tu nueva contraseña.</p>
                    </div>
                  </div>
                  {/* Formulario de Actualizar Contraseña */}
                  <div className="col-lg-6">
                    <div className="p-5">
                      <div className="text-center mb-4 d-lg-none">
                        <img
                          src={NegocioConfig.imagen}
                          alt="SIGVES LOGO"
                          className="img-fluid rounded-circle mb-3"
                          style={{ width: "150px", height: "150px" }}
                        />
                      </div>
                      <p className="login-box-msg h4 text-center">Actualizar Contraseña</p>
                      <form onSubmit={handleSubmit}>
                        <div className="form-group mb-3">
                          <div className="input-group">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Correo Electrónico"
                              value={correo}
                              onChange={(e) => setCorreo(e.target.value)}
                              autoComplete="email"
                            />
                            <div className="input-group-append">
                              <div className="input-group-text">
                                <span className="fas fa-envelope"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group mb-3">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Introduce tu PIN"
                              value={pin}
                              onChange={(e) => setPin(e.target.value)}
                              autoComplete="one-time-code"
                            />
                            <div className="input-group-append">
                              <div className="input-group-text">
                                <span className="fas fa-key"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group mb-3">
                          <div className="input-group">
                            <input
                              type={showPasswordNueva ? "text" : "password"}
                              className="form-control"
                              placeholder="Nueva Contraseña"
                              value={contrasena}
                              onChange={(e) => handlePasswordChange(e.target.value)}
                              autoComplete="new-password"
                            />
                            <div className="input-group-append">
                              <div
                                className="input-group-text"
                                onClick={() => setShowPasswordNueva(!showPasswordNueva)}
                                style={{ cursor: "pointer" }}
                              >
                                <span
                                  className={
                                    showPasswordNueva ? "fas fa-eye-slash" : "fas fa-eye"
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-group mb-3">
                          <div className="input-group">
                            <input
                              type={showPasswordVerificar ? "text" : "password"}
                              className="form-control"
                              placeholder="Verificar Contraseña"
                              value={verificarContrasena}
                              onChange={(e) => handleVerifyPasswordChange(e.target.value)}
                              autoComplete="new-password"
                            />
                            <div className="input-group-append">
                              <div
                                className="input-group-text"
                                onClick={() => setShowPasswordVerificar(!showPasswordVerificar)}
                                style={{ cursor: "pointer" }}
                              >
                                <span
                                  className={
                                    showPasswordVerificar
                                      ? "fas fa-eye-slash"
                                      : "fas fa-eye"
                                  }
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        {errorMatch && (
                          <small className="text-danger">
                            Las contraseñas no coinciden
                          </small>
                        )}
                        <div className="d-grid gap-2 mt-4">
                          <button
                            type="submit"
                            className="btn btn-primary btn-block btn-lg"
                            disabled={errorMatch}
                          >
                            Actualizar Contraseña
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActualizarContrasena;
